
import React, { useState, useEffect } from 'react';
import '../Login/login.css'; 
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import LabelText from '../../ui/LabelText';
import LoginErrorIcon from '../../assets/icons/loginError.png';
import MFLoginLogo from '../../assets/images/MF_logo.png';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PrimaryButton from '../../ui/PrimaryButton';
import { useLoading } from '../../contexts/LoadingContext';
import LoadingSpinner from '../../ui/LoadingSpinner';

const SignUpPage: React.FC = () => {

    const {signup , signupSuccess , setIsSignUpSuccess} = useAuth();
    const navigate = useNavigate();
    const {startLoading , stopLoading , loading} = useLoading();
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');
    const [errorMsg , setErrorMsg] = useState<string>('')
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPasseord, setShowConfirmPassword] = useState<boolean>(false);
    const [emailError, setEmailError] = useState('');
    const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
    const [passwordMatch , setIsPassowrdMatch] = useState<string>('')
    

    useEffect(()=>{
        if(localStorage.getItem('userData')){
            navigate('/home')
        }
    },[])

    const validatePassword = (value: string) => {
        const errors: string[] = [];
        if(value){
            if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value) || !/[!@#$%^&*(),.?":{}|<>]/.test(value) || value.length < 8) {
                errors.push("Password must contain 8 characters, include upper & lower case letters, a number, and a special character.");
            }
        }
        return errors;
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPassword(value);
        setPasswordErrors(validatePassword(value));
        if (confirmPassword !== value) {
            setIsPassowrdMatch('Password and Confirm Password do not match. Please try again.');
        }
        else{
            setIsPassowrdMatch('')
        }
    };

    const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setConfirmPassword(value);
        // setPasswordErrors(validatePassword(value));
        if (password !== value) {
            setIsPassowrdMatch('Password and Confirm Password do not match. Please try again.');
        }
        else{
            setIsPassowrdMatch('')
        }
    };
    
    const handleSignUp = async (event: React.FormEvent) => {
        event.preventDefault();
        setErrorMsg('');
        if (password !== confirmPassword) {
          setErrorMsg('Password and Confirm Password do not match. Please try again.');
          return;
        }
        try {
          startLoading();
          const { success, response } = await signup(email, confirmPassword);
          stopLoading();
          if (success) {
            setIsSignUpSuccess(true);
            // navigate('/verifyemail');
            } else {
            setIsSignUpSuccess(false)
            // Check for specific error code or message
            if (response?.error?.code === "401") {
              setErrorMsg('User already exists.');
            } else {
              setErrorMsg('Signup failed. Please try again.');
            }
          }
        } catch (error) {
          stopLoading();
          console.error('Signup error:', error);
          setErrorMsg('An error occurred. Please try again later.');
        }
      };


    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value);

        // Basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };


    return (
        <>
            <div className="login-wrapper">
                <div className="login-container" style={{width: signupSuccess ? "650px" : "", padding:"30px" }}>
                    <div className="logo center">
                        <img src={MFLoginLogo} alt="mc-football-logo" />
                    </div>
                    {signupSuccess ? (
                        <div className='signup-success-conatiner'>
                            <LabelText className='player-family-name' style={{color:'#54E0C5', textAlign:'center'}}>Thanks for Signing Up!</LabelText>
                            <LabelText>We’ve sent a verification email to your inbox.</LabelText>
                            <LabelText>Once you confirm your email, our admin team will review and approve your account.</LabelText>
                            <LabelText>You’ll be notified when you can log in and start using the app.</LabelText>
                            <LabelText>For any sign-up or login issues, please contact our support team at 
                                 &nbsp;<a href="mailto:hello@machinefootball.com" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{textDecoration:'underline',color:'#54E0C5'}}
                                >hello@machinefootball.com</a>
                            </LabelText>
                            {/* <PrimaryButton className="login-button" label="Login" onClick={()=>{navigate('/login')}}/> */}
                        </div>
                    ):(
                        <form className="login-form" autoComplete="off">
                            <LabelText className='page-title-text'>Sign Up</LabelText>
                            <div className="form-group">
                                <LabelText className='custom-list-text'>Email</LabelText>
                                <div className="input-container">
                                    <input
                                        type="text"
                                        name="username"
                                        placeholder='Enter your email address'
                                        autoComplete="off"
                                        value={email}
                                        onChange={handleEmailChange}
                                    />
                                    <span className="custom-icon">
                                        {email && (<CloseIcon onClick={()=>{setEmail('')}}/>)}
                                    </span> 
                                </div>

                                {emailError && <LabelText className='error-text'>{emailError}</LabelText>}
                            </div>
                            <div className="form-group">
                                <LabelText className='custom-list-text'>Password</LabelText>
                                <div className="input-container">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder='Enter your password'
                                        autoComplete="off"
                                        value={password}
                                        onChange={handlePasswordChange}
                                    />
                                    {password &&(
                                        <span className="custom-icon" onClick={()=>{setShowPassword(!showPassword)}}>
                                            {showPassword ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                        </span>
                                    )}
                                </div>
                            {passwordErrors && <LabelText className='error-text'>{passwordErrors}</LabelText>}
                            </div>
                            <div className="form-group">
                                <LabelText className='custom-list-text'>Confirm Password</LabelText>
                                <div className="input-container">
                                    <input
                                        type={showConfirmPasseord ? "text" : "password"}
                                        name="password"
                                        placeholder='Enter confirm password'
                                        autoComplete="off"
                                        value={confirmPassword}
                                        onChange={handleConfirmPasswordChange}
                                    />
                                    {confirmPassword &&(
                                        <span className="custom-icon" onClick={()=>{setShowConfirmPassword(!showConfirmPasseord)}}>
                                            {showConfirmPasseord ? <VisibilityIcon/> : <VisibilityOffIcon />}
                                        </span>
                                    )}
                                </div>
                                {passwordMatch && (<LabelText className='error-text'>{passwordMatch}</LabelText>)}                              
                            </div>
                            
                        </form>
                   )} 
                    {errorMsg &&(
                        <div className='error-container'>
                            <img src={LoginErrorIcon}/>
                            <LabelText className='error-text'>{errorMsg ? errorMsg : ''}</LabelText>
                        </div>
                    )}
                    {!signupSuccess && (
                        <div>
                            <LabelText>Already have an account?</LabelText>
                            <LabelText> <a style={{textDecoration:'underline',color:'#54E0C5'}} onClick={()=>{navigate('/login')}}> Log in</a></LabelText>
                        </div>
                    )}
                    {!signupSuccess &&(
                        <div className="form-actions">
                            <PrimaryButton className="login-button" label="Sign Up" onClick={handleSignUp}
                            disabled={email === '' || password === '' || confirmPassword === '' || passwordMatch !== '' || passwordErrors === null}/>
                        </div>
                    )} 
                </div>
            </div>
            {loading && <LoadingSpinner />}
        </>
    );
};

export default SignUpPage;
